import React from 'react';
import SkeletonElement from '../../../SkeletonElement';

const SkeletonMyOrders = () => {
    return (
        <div className="flex flex-col shadow-xl px-4 py-6 w-[90%] h-[400px] lg:w-[75%] lg:h-[250px] ">
            <div className="flex flex-col lg:flex-row mt-2">
                <div className="flex-shrink-0">
                    <SkeletonElement type="thumbnail" size="h-36 w-36" />
                </div>
                <div className="flex flex-col lg:px-4 flex-grow pt-3">
                    <SkeletonElement type="text" />
                    <div className="mt-2">
                        <SkeletonElement type="title" />
                        <div className="mt-6">
                            <SkeletonElement type="title" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonMyOrders;
